import { Covenant } from "store/types/deal/covanents";

export const COVENANT_TYPES = [
  { key: "leverage_ratio", label: "Leverage Ratio" },
  { key: "dscr", label: "Debt Service Coverage Ratio (DSCR)" },
  { key: "interest", label: "Interest Coverage Ratio" }
];

export const componentNameToTitle = {
  ebitda: "EBITDA",
  leverage_ratio: "Leverage Ratio",
  total_debt: "Total Debt"
};

export const covanentTypesToComponents: Record<string, Covenant["components"]> = {
  leverage_ratio: {
    ebitda: [],
    total_debt: []
  },
  dscr: {
    debt_service: [],
    ebitda: []
  },
  interest: {
    interest_expense: [],
    ebitda: []
  }
};
